import React, { useState } from 'react';

const GrammarBottomNav = ({ buttons = [] }) => {
  const [hoveredId, setHoveredId] = useState(null);

  if (!buttons.length) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 sm:hidden">
      {/* Frosted glass bar */}
      <div
        className="bg-white/90 backdrop-blur-xl border-t border-[#E1E4E8]"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="flex items-stretch justify-around h-16 px-2 max-w-lg mx-auto">
          {buttons.map((btn) => {
            if (!btn) return null;

            const isHovered = hoveredId === btn.id;
            const isActive = btn.active;
            const isDisabled = btn.disabled;
            const Icon = btn.icon;

            const accentColor = btn.color || '#006D77';
            const inactiveColor = '#9CA3AF';
            const iconColor = btn.iconColor || (isActive ? accentColor : isDisabled ? '#D1D5DB' : inactiveColor);
            const labelColor = btn.labelColor || (isActive ? accentColor : isDisabled ? '#D1D5DB' : '#6B7280');

            if (btn.type === 'progress') {
              return (
                <div
                  key={btn.id}
                  className="flex flex-col items-center justify-center px-2 min-w-[56px]"
                >
                  <div className="relative w-10 h-10 flex items-center justify-center">
                    {/* Circular progress ring */}
                    <svg className="w-10 h-10 -rotate-90" viewBox="0 0 36 36">
                      <circle
                        cx="18" cy="18" r="15"
                        fill="none"
                        stroke="#E5E7EB"
                        strokeWidth="3"
                      />
                      <circle
                        cx="18" cy="18" r="15"
                        fill="none"
                        stroke={accentColor}
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeDasharray={`${(btn.progress || 0) * 94.2 / 100} 94.2`}
                        className="transition-all duration-500 ease-out"
                      />
                    </svg>
                    <span className="absolute inset-0 flex items-center justify-center text-[11px] font-bold text-black">
                      {btn.current}/{btn.total}
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <button
                key={btn.id}
                onClick={btn.onClick}
                disabled={isDisabled}
                onMouseEnter={() => setHoveredId(btn.id)}
                onMouseLeave={() => setHoveredId(null)}
                className={`
                  flex flex-col items-center justify-center gap-0.5 px-2 min-w-[56px] min-h-[44px]
                  transition-all duration-200 touch-manipulation
                  ${isDisabled ? 'opacity-40 cursor-not-allowed' : 'active:scale-95'}
                  ${isActive ? 'relative' : ''}
                `}
                aria-label={btn.label}
              >
                {/* Active indicator dot */}
                {isActive && btn.showActiveIndicator !== false && (
                  <div
                    className="absolute -top-0.5 w-5 h-0.5 rounded-full"
                    style={{ backgroundColor: accentColor }}
                  />
                )}

                {/* Icon container */}
                <div
                  className={`
                    flex items-center justify-center w-8 h-8 rounded-xl transition-all duration-200
                    ${isActive ? 'scale-110' : ''}
                    ${isHovered && !isDisabled ? 'scale-105' : ''}
                    ${isHovered && !isDisabled && !btn.iconContainerStyle ? 'bg-gray-100' : ''}
                  `}
                  style={btn.iconContainerStyle}
                >
                  {Icon && (
                    <Icon
                      className="w-[22px] h-[22px] transition-colors duration-200"
                      style={{ color: iconColor }}
                      strokeWidth={isActive ? 2.5 : 2}
                    />
                  )}
                </div>

                {/* Label */}
                <span
                  className="text-[10px] leading-none font-medium transition-colors duration-200"
                  style={{ color: labelColor }}
                >
                  {btn.label}
                </span>

                {/* Badge */}
                {btn.badge && (
                  <div
                    className="absolute -top-1 right-1 min-w-[16px] h-4 flex items-center justify-center px-1 rounded-full text-white text-[9px] font-bold"
                    style={{ backgroundColor: accentColor }}
                  >
                    {btn.badge}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default GrammarBottomNav;
